import { render, staticRenderFns } from "./TaxMonitoringModal.vue?vue&type=template&id=1d1f5490"
import script from "./TaxMonitoringModal.vue?vue&type=script&lang=js"
export * from "./TaxMonitoringModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports